import type { RouteLocationNormalizedLoaded } from 'vue-router'

import { ref, watch } from 'vue'

import { storeToRefs } from 'pinia'
import { useUiStore } from '@/stores/ui'
import { useAuthStore } from '@/stores/auth'
import { useUsersStore } from '@/stores/users'

import { useCustomerAuthStore } from '@/stores/customer/auth'
import { useCustomerProfileStore } from '@/stores/customer/profile'
import { useCartStore } from '@/stores/customer/cart'

export const useAuth = (route: RouteLocationNormalizedLoaded) => {
  /**
   * Инициализируем ui, в нем забираем данные из localStorage и инициализируем
   * authStore в первый раз (внутри uiStore),
   * заодно запрашиваем корзину
   * */
  const ui = useUiStore()
  const authStore = useAuthStore()
  const { authorized, currentUser } = storeToRefs(authStore)

  const customerAuthStore = useCustomerAuthStore()
  const { authorized: customerAuthorized } = storeToRefs(customerAuthStore)

  const usersStore = useUsersStore()
  const customerProfileStore = useCustomerProfileStore()

  const cartStore = useCartStore()
  const isFirst = ref(true)

  watch(
    () => route.name,
    async () => {
      if (!route.name) return

      const isManager = /manager/.test(route.name as string)

      if (isManager) {
        if (authorized.value) return

        await authStore.setAuthHeader()

        authorized.value = !!authStore.authToken

        if (!authorized.value) return

        currentUser.value = await usersStore.fetchCurrentUserInfo()
      } else {
        if (customerAuthorized.value) return

        await customerAuthStore.setAuthHeader()

        customerAuthorized.value = !!customerAuthStore.authToken

        if (customerAuthorized.value) await customerProfileStore.fetchProfile()

        if (isFirst.value) {
          isFirst.value = false

          await cartStore.sendCart()
        }
      }
    }
  )

  return {
    authorized,
  }
}
